export const classroomDtoFields = [{
        name: "code",
        title: "Code",
        render: (record) => record.classroom.code
    }, {
        name: "name",
        title: "Name",
        render: (record) => record.classroom.name
    }, {
        name: "defaultCompilerDescription",
        title: "Default Compiler",
        render: (record) => record.defaultCompilerDescription
    }];
